import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import LitImage from './images/LitImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import useScreenSize from '../hooks/useScreenSize';
const ArticleGrid = ({
  categories,
  pageData,
  pageSlug,
  articleGridImage,
  articleGridSecondaryImage,
  backgroundColor,
  defaultNewsImage,
}) => {
  const [dateOrder, setDateOrder] = useState('descending');
  const [filterCategory, setFilterCategory] = useState('all');
  const [showSort, setShowSort] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filteredData, setFilteredData] = useState(pageData);

  const dateOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  const screenSize = useScreenSize();
  useEffect(() => {
    if (filterCategory === 'all') {
      setFilteredData(pageData);
    } else if (filterCategory) {
      setFilteredData(
        pageData.filter((data) => {
          return (
            data.category?.name.toLowerCase() === filterCategory.toLowerCase()
          );
        }),
      );
    }
  }, [filterCategory]);
  const sortInner = (
    <select
      className="article-sort-inner"
      onChange={(event) => {
        setDateOrder(event.target.value);
        setShowSort(false);
      }}
      name="sort"
      size="2"
    >
      <option
        value="ascending"
        className={`${dateOrder === 'ascending' && `highlight`}`}
      >
        Ascending
      </option>
      <option
        value="descending"
        className={`${dateOrder === 'descending' && `highlight`}`}
      >
        Descending
      </option>
    </select>
  );
  const filterCategoryLength = categories.filter(
    (category) => !Object.values(category).includes(''),
  );
  const filterInner = (
    <select
      className="article-filter-inner"
      onChange={(event) => {
        setFilterCategory(event.target.value);
        setShowFilter(false);
      }}
      name="filter"
      size={filterCategoryLength.length + 1}
    >
      <option
        value="all"
        className={`${filterCategory === 'all' && `highlight`}`}
      >
        All
      </option>
      {categories.map(({ name }, index) => {
        return (
          name && (
            <option
              key={index}
              value={name}
              className={`${filterCategory === name && `highlight`}`}
            >
              {name}
            </option>
          )
        );
      })}
    </select>
  );
  return (
    <div className={`article-grid-container ${backgroundColor}`}>
      {articleGridImage && (
        <div className="article-grid-image">
          <LitImage image={articleGridImage} alt="illustrated rocked" />
        </div>
      )}
      <div className="article-grid-button-container">
        <div className="article-sort">
          {screenSize.width > 750 && (
            <label
              for="sort"
              onClick={() => {
                setShowSort(!showSort);
                setShowFilter(false);
              }}
            >
              Sort{' '}
              <span className={`${showSort && 'rotate'}`}>
                <FontAwesomeIcon icon={faChevronDown} />
              </span>
            </label>
          )}
          {showSort && sortInner}
          {screenSize.width <= 750 && (
            <div className="article-sort-mobile">
              <label
                for="sort"
                onClick={() => {
                  setShowFilter(false);
                }}
              >
                Sort
              </label>
              <select
                className="article-sort-inner-mobile"
                onChange={(event) => {
                  setDateOrder(event.target.value);
                  setShowSort(false);
                }}
                name="sort"
              >
                <option value="">Sort</option>
                <option
                  value="ascending"
                  className={`${dateOrder === 'ascending' && `highlight`}`}
                >
                  Ascending
                </option>
                <option
                  value="descending"
                  className={`${dateOrder === 'descending' && `highlight`}`}
                >
                  Descending
                </option>
              </select>
            </div>
          )}
        </div>
        <div className="article-filter">
          {screenSize.width > 750 && (
            <label
              for="filter"
              onClick={() => {
                setShowFilter(!showFilter);
                setShowSort(false);
              }}
            >
              Filter
              <span className={`${showFilter && 'rotate'}`}>
                <FontAwesomeIcon icon={faChevronDown} />
              </span>
            </label>
          )}
          {showFilter && screenSize.width > 750 && filterInner}
          {screenSize.width <= 750 && (
            <div className="article-filter-mobile">
              <label
                for="filter"
                onClick={() => {
                  setShowFilter(!showFilter);
                  setShowSort(false);
                }}
              >
                Filter
              </label>
              <select
                className="article-filter-inner-mobile"
                onChange={(event) => {
                  setFilterCategory(event.target.value);
                }}
                name="filter"
              >
                {' '}
                <option value="">Filter</option>
                <option
                  value="all"
                  className={`${filterCategory === 'all' && `highlight`}`}
                >
                  All
                </option>
                {categories.map(({ name }, index) => {
                  return (
                    name && (
                      <option
                        key={index}
                        value={name}
                        className={`${filterCategory === name && `highlight`}`}
                      >
                        {name}
                      </option>
                    )
                  );
                })}
              </select>
            </div>
          )}
        </div>
      </div>

      <div className="article-card-grid" id={`${pageSlug}Container`}>
        {filteredData
          .sort((a, b) => {
            return dateOrder === 'ascending'
              ? new Date(a.publishedDate) - new Date(b.publishedDate)
              : new Date(b.publishedDate) - new Date(a.publishedDate);
          })
          .map(
            (
              {
                slug,
                previewText,
                content,
                category,
                title,
                previewImage,
                publishedDate,
              },
              i,
            ) => (
              <div className="article-card-grid-inner" key={i}>
                <Link to={`/${pageSlug}/${slug}/`}>
                  <div className="article-card">
                    <div className="article-card-image">
                      <LitImage
                        image={previewImage ?? defaultNewsImage}
                        alt={title}
                        loading="lazy"
                      />
                    </div>
                    <div className="article-card-content">
                      <p className="category-news">{category?.name}</p>
                      {/* <h5>{title}</h5> */}
                      <h6>
                        {title.value ? (
                          <LitStructuredText data={title} basic />
                        ) : (
                          title
                        )}
                      </h6>
                      <div className="article-card-date-read-time">
                        <span>
                          {new Date(publishedDate).toLocaleString(
                            [],
                            dateOptions,
                          )}
                        </span>
                      </div>
                      <Link to={`/${pageSlug}/${slug}/`} className="button">
                        Read more
                      </Link>
                    </div>
                  </div>
                </Link>
              </div>
            ),
          )}
      </div>
      {articleGridSecondaryImage && (
        <div className="article-grid-image-secondary">
          <LitImage
            image={articleGridSecondaryImage}
            alt="illustrated rocket tail"
          />
        </div>
      )}
    </div>
  );
};

export default ArticleGrid;
